/*
 * Copyright (c) 2019 LNBIG.com
 * All rights reserved.
 */

import glue          from "@/CommandGlue"
import dbg           from "debug"
import injectCaptcha from './injectCaptcha'

const debug = dbg('lnbig:store:addMerchant')

let obj = {
    namespaced: true,
    state: {
        addMerchantComponent: null
    },

    getters: {
    },

    mutations: {
        cmdCheckInvoiceResult(state, message) {
            glue.find(
                'cmdCheckInvoiceResult',
                message,
                (message, component) => {
                    if (message.result && message.result === 'OK')
                        component.messageOfScan = message.message
                    else if (message.result === 'FAIL')
                        state.addMerchantComponent.errorOfScan = message.reason
                    if (message.claim)
                        state.addMerchantComponent.claimLnurl = message.claim
                }
            )
        },

        cmdOpenChannelResult(state, message) {
            // Вызывается сервером с результами открытия канала. Может иметь message.error в случае ошибки
            if (message.result === 'OK')
                state.addMerchantComponent.messageOfScan = message.message
            else if (message.result === 'FAIL')
                state.addMerchantComponent.errorOfScan = message.reason
            if (message.claim)
                state.addMerchantComponent.claimLnurl = message.claim

        },

        setAddMerchantComponent(state, el) {
            state.addMerchantComponent = el
        }
    },

    actions: {
        async checkInvoiceData({rootState, dispatch, commit}, component) {
            let promise

            if (!rootState.webSocket && rootState.webSocketError) {
                throw new Error(rootState.webSocketError)
            }
            if (! rootState.helloPromise)
                throw new Error("Non-standard error: hello handshake was not made but should be");
            await rootState.helloPromise

            // Распознаём текущий трафик бот/не_бот
            // Этот actRecaptchaV3 был внесён через injectCaptcha
            if (! await dispatch('actRecaptchaV3')) {
                if ( ! await dispatch('actRecaptchaV2', component))
                    throw new Error("You defined as bot. Sorry but you cannot open a channel here")
            }
            promise = glue.add(
                (uuid) => {
                    // Здесь мы либо получаем LNURL, либо API команды для открытия канала
                    rootState.webSocket.sendObj({
                        uuid,
                        command: 'cmdCheckInvoiceData',
                        namespace: 'addMerchant',
                        invoice: component.scannedInvoice
                    });

                    debug('Послали команду cmdGetOpenChannel(Lnurl/Api) на сервер')
                },
                'cmdCheckInvoiceResult',
                component,
                10000
            )
            return promise
        }
    }
}

obj = injectCaptcha(obj, 'addMerchant', 'addMerchant')

debug('После injectCaptcha, addMerchant: %o', obj)

export default obj
